'use strict';

const Mn = require('backbone.marionette');
const ContentView = require('balus/ui/view/body/user/content/index');
const ContentTemplate = require('balus/ui/template/body/user/index.hbs');
const RecentChangeActionCreator = require('common/domain/action/recent-change');
const Config = require('balus/config');

module.exports = Mn.View.extend({
    className: 'row',
    template: ContentTemplate,
    regions: {
        content: '#content'
    },

    onRender: function() {
        this.showChildView('content', new ContentView({
            model: this.model,
            context: this.getOption('context')
        }));

        RecentChangeActionCreator.fetchRecentChangesOnce({
            kind: 'Group',
            offset: 0,
            limit: Config.recentChange.firstFetchLimit + 1
        });
        RecentChangeActionCreator.fetchRecentChangesOnce({
            kind: 'Project',
            offset: 0,
            limit: Config.recentChange.firstFetchLimit + 1
        });
        RecentChangeActionCreator.fetchRecentChangesOnce({
            kind: 'DataSet',
            offset: 0,
            limit: Config.recentChange.firstFetchLimit + 1
        });
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/user/index.js